<template>
    <div>
        <!-- <h5 class="text-center">Steps Builder</h5> -->
        <div class="flex builder-container">
            <company-block-list class="col-12 md:col-3 shadow-2" @dragged-block="setDraggedBlock" />
            <assessment-builder class="col-12 md:col-5 shadow-2" @drop="addStepDialog = true" @dragover.prevent />
            <!-- addStepDialog = true -->
            <assessment-config class="col-12 md:col-4 shadow-2" />
        </div>
        <!-- dialog to add step configuration for blocks everytime its dragged and dropped-->
        <add-step v-if="addStepDialog" @hide-dialog="hideDialog" @step-added="stepAdded" />
    </div>
</template>

<script setup>
import CompanyBlockList from '../../block/components/CompanyBlockList.vue';
import AssessmentBuilder from '../components/AssessmentBuilder.vue';
import AssessmentConfig from '../components/AssessmentConfig.vue';
import AddStep from '../modules/step/components/AddStep.vue';

import { ref, onMounted, defineProps, provide } from 'vue';

import { useAssessmentStore } from '../store';
import { useAssessmentBuilderStore } from '../store/builder';
import { useStepStore } from '../modules/step/store';
import { useLinkStore } from '../modules/link/store';
// later make sure to change FormulaComposable as well
import useFormulaComposable from '@/composables/FormulaComposable';

const props = defineProps({
    id: {
        type: [Number, String],
    },
});

// injecting store for child components usage
const assessmentStore = useAssessmentStore();
const builderStore = useAssessmentBuilderStore();
const stepStore = useStepStore();
const linkStore = useLinkStore();

const { fetchFormulas, formulas } = useFormulaComposable();
const addStepDialog = ref(false);

provide('builderStore', builderStore);
provide('stepStore', stepStore);
provide('linkStore', linkStore);
provide('formulas', formulas);
provide('assessmentId', props.id);
provide('assessmentStore', assessmentStore);

onMounted(async () => {
    // load assessment details by the props id (assessment id)
    const assessmentDetails = await assessmentStore.fetchAssessmentById(parseInt(props.id));
    // when assessment details are initially loaded steps and links are not properly formatted so it needs to be formatted before we can start seeing them in the builder
    // lets extract the steps first, make sure to filter out steps that have empty block, or null block details
    const steps = assessmentDetails?.steps?.filter((step) => step.block);
    // if there is atleast one or more steps then we will pass them in the step store to populate and format them
    if (steps.length) {
        await stepStore.populateAssessmentSteps(assessmentDetails?.steps);
    }
    // we need to load the blocks in the assessment builder as well
    // each blocks are stored inside each individual steps, so we will extract those blocks from steps and load them into droppedBlocks to make them visible in the builder UI
    const blocks = steps?.map((step) => step.block);
    // initially clean the droppedBlocks array to avoid stale information
    builderStore.droppedBlocks = [];
    // loop through the blocks and push them to dropped blocks
    blocks?.forEach((block) => {
        dropNewBlock(block);
    });

    // load the formulas -> formulas are gonna be used while creating links that might use formulas
    await fetchFormulas();
});

const setDraggedBlock = (block) => {
    builderStore.setActiveBlock(block);
};
// once the step configuration have been made then drop the blocks
const stepAdded = () => {
    // hide the dialog
    addStepDialog.value = false;

    // add the dragged block which is activeBlock in the builder store into the droppedBlocks array
    dropNewBlock(builderStore.activeBlock);
};

const dropNewBlock = (block) => {
    builderStore.droppedBlocks.push(block);
    builderStore.activeBlock = null;
};

const hideDialog = () => {
    // hide add step dialog
    addStepDialog.value = false;
    // remove active block from blockStore
    builderStore.setActiveBlock();
};
</script>

<style lang="scss" scoped>
.builder-container {
    height: 80vh;
    overflow: hidden;
}
</style>
